import { useState, useEffect } from 'react'
import i18n, { Language, TranslationKeys } from '../i18n'

export function useTranslation() {
  const [currentLanguage, setCurrentLanguage] = useState<Language>(i18n.getCurrentLanguage())

  useEffect(() => {
    const unsubscribe = i18n.subscribe((lang) => {
      setCurrentLanguage(lang)
    })

    return unsubscribe
  }, [])

  const t = (key: keyof TranslationKeys): string => {
    return i18n.translate(key)
  }

  const toggleLanguage = () => {
    i18n.toggleLanguage()
  }

  const setLanguage = (lang: Language) => {
    i18n.setLanguage(lang)
  }

  return {
    t,
    currentLanguage,
    toggleLanguage,
    setLanguage,
    isRTL: i18n.isRTL(),
    direction: i18n.getDirection(),
    fontClass: i18n.getFontClass()
  }
}